import { isSpace } from '../theme';
export const getLengthValue = ({ length, theme }) => {
    if (typeof length === 'number') {
        return `${length}px`;
    }
    if (!isSpace(length)) {
        return length;
    }
    return length.startsWith('-') ? `-${theme.space[length.slice(1, length.length)]}` : theme.space[length];
};
export const getSizeValue = (size) => {
    if (typeof size === 'number') {
        return `${size}px`;
    }
    return size;
};
